<template>
  <div class='FastProdEdit'>
    <div class="header">
      <div class="label">Edição rápida produto</div>
      <div class="close">
        <close-icon @click="close"/>
      </div>
    </div>
    <div class="cont">
      <input-reg
      :value="SelectedProdEdit.name"
      @update:model-value="newValue => ChangeProdEdit({ name: newValue })"
      text="Nome do produto"
      :cont="{ textAlign: 'left' }"
      :label="{ marginLeft: '3px' }"
      :input="{ fontSize: '26px', padding: '1.5%', width: '96%', border: 'thin solid #CCCCCC', borderRadius: '5px' }"
      />
      <input-reg
      :value="SelectedProdEdit.preco"
      @update:model-value="newValue => verifyPreco(newValue)"
      text="Preço (R$)"
      :cont="{ textAlign: 'left' }"
      :label="{ marginLeft: '3px', marginTop: '8px' }"
      :input="{ fontSize: '26px', padding: '1.5%', width: '96%', border: 'thin solid #CCCCCC', borderRadius: '5px' }"
      Money
      />
      <input-reg
      :value="SelectedProdEdit.oferta"
      @update:model-value="newValue => verifyOferta(newValue)"
      text="Preço de oferta (R$)"
      :cont="{ textAlign: 'left' }"
      :label="{ marginLeft: '3px', marginTop: '8px' }"
      :input="{ fontSize: '26px', padding: '1.5%', width: '96%', border: 'thin solid #CCCCCC', borderRadius: '5px' }"
      Money
      />
      <input-select
      :value="VisibSelected"
      @update:model-value="newValue => ChangeProdEdit({ visibilidade: visibilidade.filter(v => v.name === newValue)[0].id })"
      :data="visibilidade"
      text="Visibilidade no Catálogo"
      :label="{ textAlign: 'left', marginTop: '8px', marginLeft: '3px' }"
      :input="{ width: '99.5%', padding: '2.8%', paddingLeft: '1.2%', fontSize: '16px', border: 'thin solid #CCCCCC', borderRadius: '5px' }"
      />
    </div>
    <button v-if="!load" @click="update">Atualizar</button>
    <vue-spinner v-if="load" size="30"/>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import CloseIcon from '../Icons/CloseIcon'
import InputReg from '../Produtos/Register/InputReg'
import InputSelect from '../Produtos/Register/InputSelect'
import { VueSpinner } from 'vue3-spinners'
export default {
  name: 'FastProdEdit',
  components: { CloseIcon, InputReg, InputSelect, VueSpinner },
  data () {
    return {
      visibilidade: [
        { id: 1, name: 'Vitrine' },
        { id: 2, name: 'Loja e resultado de pesquisa' },
        { id: 3, name: 'Apenas na loja' },
        { id: 4, name: 'Apenas nos resultados de pesquisa' },
        { id: 5, name: 'Oculto' }
      ],
      load: false
    }
  },
  computed: {
    ...mapGetters(['SelectedProdEdit']),
    VisibSelected () {
      return this.visibilidade.filter(v => v.id === this.SelectedProdEdit.visibilidade)[0].name
    }
  },
  methods: {
    ...mapActions(['SetModal', 'ChangeProdEdit', 'SetModal01', 'PushMsg', '_UpdateProduct']),
    close () {
      this.SetModal({ component: '', active: false })
      this.SetModal01({ component: '', active: false })
    },
    update () {
      this.load = true
      this._UpdateProduct(this.SelectedProdEdit)
        .then(() => {
          this.close()
          this.load = false
        })
    },
    verifyPreco (preco) {
      let oferta
      if(this.SelectedProdEdit.oferta.indexOf('R$') === -1) {
        oferta = parseFloat(this.SelectedProdEdit.oferta.replace('R$ ', '').replace(',', '.'))
      }
      else {
        oferta = parseFloat(this.SelectedProdEdit.oferta.replace(/\./g, '').replace('R$ ', '').replace(',', '.'))
      }
      let prec = parseFloat(preco.replace(/\./g, '').replace('R$ ', '').replace(',', '.'))
      if(oferta > prec) {
        this.PushMsg({ msg: 'O valor da oferta não pode ser maior que o valor do produto', color: 'orange' })
        this.ChangeProdEdit({ oferta: 0 })
        return
      }
      this.ChangeProdEdit({ preco: preco })
    },
    verifyOferta (oferta) {
      let preco = parseFloat(this.SelectedProdEdit.preco.replace(/\./g, '').replace('R$ ', '').replace(',', '.'))
      let of = parseFloat(oferta.replace(/\./g, '').replace('R$ ', '').replace(',', '.'))
      if(of > preco) {
        this.PushMsg({ msg: 'O valor da oferta não pode ser maior que o valor do produto', color: 'orange' })
        this.ChangeProdEdit({ oferta: 0 })
        return
      }
      this.ChangeProdEdit({ oferta: oferta })
    }
  },
  created () {
    if(typeof this.SelectedProdEdit.oferta !== 'string') {
      this.ChangeProdEdit({ oferta: this.SelectedProdEdit.oferta.toFixed(2) })
      this.ChangeProdEdit({ preco: this.SelectedProdEdit.preco.toFixed(2) })
    }
  }
}
</script>

<style scoped>
.FastProdEdit {
  width: 40%;
  height: 65%;
  position: absolute;
  margin: auto;
  background-color: #FFFFFF;
  border-radius: 5px;
  padding-bottom: 2.5%;
}

.header {
  display: flex;
  padding: 3%;
}

.label {
  width: 50%;
  text-align: left;
  font-weight: bold;
}

.close {
  width: 50%;
  text-align: right;
}

.cont {
  padding: 3%;
  padding-top: 0%;
}

button {
  border: 0;
  font-size: 16px;
  padding: 2%;
  border-radius: 5px;
  background-color: #333333;
  color: #FFFFFF;
  cursor: pointer;
}

@media (max-width: 500px) {
  .FastProdEdit {
    width: 90%;
    height: 70%;
  }
}
</style>
